import Vue from "vue";
import App from "./App.vue";
import { router } from "./router";
import vueTouch from 'kim-vue-touch'
Vue.use(vueTouch)

// location.href = `https://qa-test-community.zlongame.com/${location.search}`

import Clipboard from 'clipboard';
Vue.prototype.Clipboard = Clipboard;
Vue.prototype.$eventBus = new Vue()


import store from './store/index';

// import VConsole from 'vconsole';
// const vConsole = new VConsole();



import { Tabbar, TabbarItem, Image as VanImage, Field, Dialog, Icon, Switch, Swipe, SwipeItem, Lazyload, ActionSheet, Tab, Tabs, Toast, Search, List, PullRefresh, Sticky, Loading, DropdownMenu, DropdownItem, Cell, CellGroup, RadioGroup, Radio,Checkbox, CheckboxGroup,Progress } from "vant";
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(VanImage);
Vue.use(Field);
Vue.use(Dialog);
Vue.use(Icon);
Vue.use(Switch);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
Vue.use(ActionSheet);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Toast);
Vue.use(Search);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Sticky);
Vue.use(Loading);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(Progress);

import VueImageCutting from './utils/vue-image-cutting/lib/VueImageCutting.umd.min'
import './utils/vue-image-cutting/lib/VueImageCutting.css'
Vue.use(VueImageCutting)

// import emjoymethod from './utils/emjoymethod'
// emjoymethod()

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

import rem from "./utils/rem";
rem();
window.onresize = function () {
  rem();
};

import getSystem from "@/utils/getSystem";
store.state.system = getSystem();

import getPad from "@/utils/getPad";
Vue.prototype.$padFalg = getPad();

import md5 from 'js-md5'
Vue.prototype.$md5 = md5

function _isMobile() {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
}

Vue.config.productionTip = false;

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

let ispc = !_isMobile()
Vue.use(preview, {
  fullscreenEl: false, //控制是否显示右上角全屏按钮
  closeEl: ispc, //控制是否显示右上角关闭按钮
  tapToClose: true, //点击滑动区域应关闭图库
  shareEl: false, //控制是否显示分享按钮
  zoomEl: false, //控制是否显示放大缩小按钮
  counterEl: true, //控制是否显示左上角图片数量按钮
  arrowEl: true,  //控制如图的左右箭头（pc浏览器模拟手机时）
  tapToToggleControls: true, //点击应切换控件的可见性
  clickToCloseNonZoomable: true //点击图片应关闭图库，仅当图像小于视口的大小时
})

function highlightText(text, keyword) {
  if (!keyword) return text;
  const regex = new RegExp(keyword, 'gi');
  return text?.replace(regex, function (match) {
    return `<span class="high_light">${match}</span>`;
  });
}

Vue.directive('highlight', function (el, binding) {
  let highlightedText = highlightText(binding.value.text, binding.value.keyword);
  el.innerHTML = highlightedText;
})



new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");